import React, { FC } from 'react'

import { Box, Stack, Typography, useTheme } from '@mui/material'

type JournalingModalSectionTitlePropsType = {
  step: number
  title: string | null
}

const JournalingModalSectionTitle: FC<JournalingModalSectionTitlePropsType> = ({ step, title }) => {
  const { spacing, palette } = useTheme()

  return (
    <Stack alignItems="center" direction={'row'} spacing={1} flexWrap={'nowrap'}>
      <Box
        sx={{
          height: spacing(3),
          width: spacing(3),
          borderRadius: '50%',
          backgroundColor: palette.divider,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: 'translateX(-50%)',
        }}
      >
        <Typography fontSize={12} fontWeight="bold">
          {step}
        </Typography>
      </Box>

      <Typography
        variant="h3"
        sx={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          flex: 1,
        }}
      >
        {title}
      </Typography>
    </Stack>
  )
}

export default JournalingModalSectionTitle
